import React, { useEffect, useRef, useState } from 'react';
import { View } from "react-native"
import Colors from '../../../constants/Colorsv2';
import { useIsInViewport } from '../../../utilsv1/helpers';
import { Text } from '../../../globalComponents/NativeOverrides';

type StreamCardProps = {
    width:number,
    url: string,
    hide?:boolean,
    stream_type?: 'iframe' | 'youtube' | 'instagram' | 'twitch',
    twitch_type?: 'channel' | 'video'
    onHeightChange?: (height:number) => void
}

const MAX_WIDTH = 450;
const MIN_WIDTH = 350;

const StreamCard = ({ hide, width, stream_type, twitch_type, url, onHeightChange }: StreamCardProps) => {
    const [ stream_url, setStreamUrl ] = useState<string | undefined>(undefined)
    const [ twitch_player, setTwitchPlayer ] = useState<any|undefined>(undefined)
    const video_ref = useRef()

    useEffect(() => {
        if(!url){ return }
        switch(stream_type){
            case 'iframe': return setStreamUrl(url)
            case 'youtube': 
                let parse_link = url.split('/')
                return setStreamUrl(`https://www.youtube.com/embed/${parse_link[parse_link.length -1]}`)
            case 'twitch':
                if(hide){ return }
                let parse_twitch = url.split('/')
                loadTwitchVideo(parse_twitch[parse_twitch.length - 1], twitch_type)
                return
            default: return setStreamUrl(url)
        }
    },[url, hide])

    const loadTwitchVideo = async(id:string, twitch_type?:string) => {
        
        if(window.Twitch && twitch_player){
            if(twitch_type == 'channel'){
                setTwitchPlayer(twitch_player.setChannel(id))
            } else {
                setTwitchPlayer(twitch_player.setVideo(id))
            }
        } //Already loaded the twitch script!
        let script = document.createElement('script');
        script.id = 'twitch';
        script.src = 'https://player.twitch.tv/js/embed/v1.js'
        script.async = true;
        script.defer = true;
        script.onload = () => {
            //Once loaded, we can add in the video
            if(twitch_type == 'channel'){
                setTwitchPlayer(new window.Twitch.Player("twitch-embed", {
                    channel: id,
                    width: width,
                    height: width * 0.75
                }))
            } else {
                setTwitchPlayer(new window.Twitch.Player("twitch-embed", {
                    video: id,
                    width: width,
                    height: width * 0.75
                }))
            }
            
        }
        script.onerror = (e) => console.log(e);
        document.body.appendChild(script);
    }

    const handleHeightChange = (height:number) => {
        if(stream_type == 'instagram'){ console.log(height)}
        if(!onHeightChange){ return }
        onHeightChange(height)
    }

    if(hide){ return <></> }
    let insta_width = width>MAX_WIDTH?MAX_WIDTH:width
    if(insta_width < MIN_WIDTH){ insta_width = MIN_WIDTH }
    let insta_height = insta_width * 1.8
    
    return (
        <View style={{overflow:'hidden'}}>
            <View style={{ backgroundColor:Colors.shades.white }} onLayout={(ev) => {
                const { height } = ev.nativeEvent.layout;
                handleHeightChange(height)
            }}>
                {stream_type === 'iframe' ?
                <iframe src={stream_url} allow='autoplay; picture-in-picture;' allowFullScreen style={{ border:0, width, height:width/1.5 }} />
                : stream_type == 'twitch' ?
                <div id="twitch-embed"></div>
                : stream_type === 'instagram' ?
                <View>
                    <iframe
                    ref={video_ref}
                    src={`${stream_url}`} 
                    allow='autoplay; picture-in-picture;'
                    allowFullScreen 
                    style={{ 
                        border:0,
                        alignSelf:'center', 
                        width:insta_width, 
                        height:insta_height, 
                        marginTop: -insta_height * 0.075,
                        marginBottom: -insta_height * 0.225
                    }} 
                    />
                </View>
                : stream_type === 'youtube' ?
                <iframe
                src={stream_url}
                style={{ border:0, width, height:width/1.5 }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                title="Embedded youtube"
            />
            :<></>}
            </View>
        </View>
    )
}

export default StreamCard